var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 62,
    viewBox: "0 0 36 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81932 1.06932C3.16175 -0.273107 5.33825 -0.273107 6.68068 1.06932L34.1807 28.5693C35.5231 29.9117 35.5231 32.0883 34.1807 33.4307L6.68068 60.9307C5.33825 62.2731 3.16175 62.2731 1.81932 60.9307C0.476893 59.5883 0.476893 57.4117 1.81932 56.0693L26.8886 31L1.81932 5.93068C0.476893 4.58825 0.476893 2.41175 1.81932 1.06932Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselRightArrow);
export default __webpack_public_path__ + "static/media/CarouselRightArrow.2cb483a6fac73fd72f75cfd944d45c69.svg";
export { ForwardRef as ReactComponent };